/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import './store';
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator';
import {
  Field,
  Formatter,
  Validator,
  Form,
  ValidateError,
} from '@hb/finance-ui';
import { debounce } from 'lodash';
import { namespace } from 'vuex-class';
import { Toast } from '@hb/coffee';
import { ContractItem } from '@/ContractConfig';
import { SessionEnum } from '@/enums/session';
import { local, session } from '@/shared/utils/storage';
import {
  CardTypeEnum,
  BindCardFlowTypeMap,
} from '@/api/bank-card/types';

import type {
  SendSmsOrBindCardResult,
  BankInfoOfCardNo,
  BindCardParamsTypes,
  SupportBankCard,
  QueryBankInfoParams,
} from '@/api/bank-card/types';

import RouterHelper from '@/shared/utils/routerHelper';
import { ubtButton, ubtPageButton, ubtSendError } from '@/shared/utils/ubt';
import {
  HUANTAIHUAQIAN_COMMODITY,
  JINCHENG_COMMODITY, MINSHENG_COMMODITY, TIANCHENG_COMMODITY, XIAOHUA_COMMODITY, YINHE_COMMODITY,
} from '@/shared/commodity';
import platform from '@/shared/utils/platform';
import FinanceBusiness from '@/mixins/finance-business';
import router from '@/router';
import { trimAll } from '@/shared/utils/trim';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import QuickBindCard from '@/components/quick-bind-card';
import { QuickBindCardResult } from '@/components/quick-bind-card/types';
import { RouterV2Enum } from '@/router/router-names';
import { IBankData } from '@/api/quick-bind-card/types';
import { setIosBouncesEable } from '@/api/native';
import { pickObjectProperty } from '@/shared/utils/pickObjectProperty';
import { sleep } from '@/shared/utils/sleep';
import { LocalEnum } from '@/enums/local';
import { closeWebView, nativeLocalSetData } from '@/api/native/utils';
import { checkBindCardNeedVerify } from '@/shared/verify-credit-controller';
import SmsConfirm from './components/sms-confirm';
import ContractList from './components/contract-list';
import { FormInfomation, SessionFrom, BindingCardChineseCMap } from '../card-list/types';
import { CardTypeNameOptions, BackQuickBindContext } from './types';
import SupportList from './components/support-list';

const style = require('./index.module.scss');

const CardBindStore = namespace('cardBind');
const ApplyProductStore = namespace('applyProduct');

// 需要使用钩子的场景 要先注册（目前只有首页注册了）
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

const BackQuickBindCacheKeys = {
  BANK_INFO: 'back_quick_bind__bank_info',
  PAGE_CONTEXT: 'back_quick_bind__page_context',
  FINAL_RESULT: 'back_quick_bind__final_result',
};

type FieldComponent = Field & { validateMessage: string };

/** 银行卡类型不支持，错误提示 */
const DEFAULT_CARD_TYPE_NOT_SUPPORT_MSG = '仅支持储蓄卡，请更换银行卡类型';

@Component
export default class CardBind extends Mixins(
  FinanceBusiness,
) {
  @CardBindStore.State userName!: string;

  @CardBindStore.State bankInfo!: BankInfoOfCardNo;

  @CardBindStore.State shouldMaskPhoneNo!: boolean;

  @CardBindStore.State shouldMaskCardNo!: boolean;

  @CardBindStore.State defaultCardNo!: string;

  @CardBindStore.State isBankSupported!: boolean | undefined;

  @CardBindStore.State sendSmsOrBindCardResult!: SendSmsOrBindCardResult;

  @CardBindStore.State contractList!: ContractItem[];

  @CardBindStore.Action $updateState!: (data: Dictionary) => void;

  @CardBindStore.Action $resetState!: () => void;

  @CardBindStore.Action getUserInfo!: () => Promise<void>;

  @CardBindStore.Action sendSmsOrBindCard!: (params: BindCardParamsTypes) => Promise<boolean>;

  @CardBindStore.Action getBankInfoByCardNo!: (params: QueryBankInfoParams) => Promise<BankInfoOfCardNo>;

  @CardBindStore.Action getContractList!: (payload: {
    commodityId: string;
    capitalCode?: string;
  }) => Promise<void>;

  @CardBindStore.Action getCardNoByUserBankId!: (
    commodityId: string
  ) => Promise<void>;

  @CardBindStore.State supportList!: SupportBankCard[];

  @CardBindStore.Action getSupportList!: (
    commodityId: string,
    capitalCode: string
  ) => void;

  @ApplyProductStore.Action('$updateState') updateLoanBankCard!: (
    data: Dictionary
  ) => void;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode!: string;

  @Prop(String) readonly loanOrderId!: string;

  @Prop(String) readonly entryFrom!: FormInfomation;

  @Prop(String) readonly userBankId!: string;

  // 用户选择银行卡前的来源页面，目前只适配于还款流程
  @Prop(String) readonly fromPath!: string;

  // 用户选择银行后的返回页面，目前只适配于还款流程
  @Prop(String) readonly backPath!: string;

  // 用于选择银行卡后继续前进的页面，目前只适配于还款流程
  @Prop(String) readonly forwardUrl!: string;

  /** 回退时的history序列 */
  @Prop(String) readonly fromHistoryLength!: string;

  @Prop(Boolean) readonly isPreCredit!: boolean;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  /** 是否检验资方能否支持该银行卡，比如 */
  private get isCheckCapitalSupport() {
    return [FormInfomation.Product, FormInfomation.QuickWithdraw].includes(this.entryFrom);
  }

  /** 银行卡类型-检验失败提示文案 */
  private cardTypeErrorMessage = DEFAULT_CARD_TYPE_NOT_SUPPORT_MSG;

  /** 是否为“一键绑卡”后的回跳 */
  private isLoadFromQuickBindBack = false;

  /** 离开页面的上下文 */
  private backQuickBindContext: BackQuickBindContext | null = null;

  constructor() {
    super();
    this.listenQuickBindHistoryOnceEvent = this.listenQuickBindHistoryOnceEvent.bind(this);
  }

  /** 一键绑卡跳转流程是否使用新开Webview方式: 授信 不启用 */
  private get isQuickBindByUseNewWebview() {
    return ![FormInfomation.Credit].includes(this.entryFrom);
  }

  // 银行卡号
  private get cardNo(): string {
    return String(this.$store.state.cardBind.cardNo);
  }

  private set cardNo(value: string) {
    if (this.shouldMaskCardNo
      && value.length < Formatter.cardNoFormatter(this.defaultCardNo).length) {
      this.$updateState({
        cardNo: '',
        shouldMaskCardNo: false,
        // 更新卡号需要重新发送短信验证码
        sendSmsOrBindCardResult: undefined,
      });
    } else {
      this.$updateState({
        cardNo: value,
        // 更新卡号需要重新发送短信验证码
        sendSmsOrBindCardResult: undefined,
      });
    }
  }

  // 是否银河
  private get isYHProductChannel() {
    return [YINHE_COMMODITY].indexOf(this.commodityId) >= 0;
  }

  // 增加判断，表示当前渠道是否需要合同展示
  private get needContract() {
    return !this.isYHProductChannel && !this.bRProductId && !this.isTIANCHENG
      && !([HUANTAIHUAQIAN_COMMODITY].indexOf(this.commodityId) >= 0);
  }


  // 是否甜橙金融-翼支付
  private get isTIANCHENG() {
    return [TIANCHENG_COMMODITY].indexOf(this.commodityId) >= 0;
  }

  // 百融三家渠道
  private get bRProductId() {
    return [
      JINCHENG_COMMODITY,
      MINSHENG_COMMODITY,
    ].indexOf(this.commodityId) >= 0;
  }

  // 手机号
  protected get reservePhone(): string {
    return String(this.$store.state.cardBind.reservePhone);
  }

  protected set reservePhone(value: string) {
    if (this.shouldMaskPhoneNo && value.length < 13) {
      this.$updateState({
        reservePhone: '',
        shouldMaskPhoneNo: false,
        sendSmsOrBindCardResult: undefined,
      });
    } else {
      this.$updateState({
        reservePhone: value,
        sendSmsOrBindCardResult: undefined,
      });
    }
  }

  // 手机号
  protected get defReservePhone(): string {
    return String(this.$store.state.cardBind.defaultReservePhone);
  }

  // 是否显示支持银行列表
  private isSupportListVisible = false;

  // 是否展示协议列表
  private isContractListVisible = false;

  // 显示短信验证码弹窗
  private isSmsDialogVisible = false;

  // 立即验证按钮是否可点击
  private isButtonClickable = false;

  /** 输入区域是否折叠起来  */
  private isInputFormFold = true;

  // 是否是有效银行卡号
  private isValidCardNo = false;

  private get onCardNoSuccWithDebounce() {
    return debounce(this.onCardNoSucc.bind(this), 200);
  }

  private get submitFormWithDebounce() {
    // 延长防抖时长，减少用户重复点击造成后端接口日志告警的问题
    return debounce(this.submitForm.bind(this), 1000);
  }

  // 甜橙金融
  private get tianChengProductId() {
    return [
      TIANCHENG_COMMODITY,
      MINSHENG_COMMODITY,
    ].indexOf(this.commodityId) >= 0;
  }

  // 盛银消金
  private get getContractNameSY() {
    return (
      this.commodityId && [XIAOHUA_COMMODITY].indexOf(this.commodityId) >= 0
    );
  }

  /** 获取来源场景中文 */
  private get entryFromValue() {
    return BindingCardChineseCMap[this.entryFrom] || '';
  }

  // 监听发送短信验证码结果
  @Watch('sendSmsOrBindCardResult')
  private onSendSmsOrBindCardResultChange() {
    if (this.sendSmsOrBindCardResult) {
      if (!this.sendSmsOrBindCardResult.bandStatus) {
        this.isSmsDialogVisible = true;
      } else {
        this.onCardBindSucc(this.sendSmsOrBindCardResult.bankCardId);
      }
    }
  }

  // 埋点
  @Watch('isSmsDialogVisible')
  private onIsSmsDialogVisibleChange() {
    ubtPageButton(
      this,
      `${this.isSmsDialogVisible ? 'Show' : 'Hide'}SmsDialog`,
      'commodityId',
      this.commodityId,
      'entryFrom',
      this.entryFromValue,
    );
  }

  private created() {
    // 设置ios弹性滚动禁止
    setIosBouncesEable(false);

    RouterHelper.setBackConfirm({
      ...this.$route.meta.backConfirmDialog,
      beforeCancel: () => ubtButton(
        '臻有钱_验证银行卡信息页',
        '臻有钱_验证银行卡信息页_残忍离开',
        'commodityId',
        this.commodityId,
        'entryFrom',
        this.entryFromValue,
      ),
    });
  }

  private async mounted() {
    // 新增进入页面曝光埋点
    this.$ubtModuleExpose(
      'finance_addNewCard',
      'commodityId',
      this.commodityId,
      'entryFrom',
      this.entryFromValue,
    );
    if (this.ocrAfterLoan) {
      await checkBindCardNeedVerify([this.commodityId]);
    } else if (this.isPreCredit) {
      /** 预授信流程-只检验前置OCR流程 */
      await this.preCreditBeforeEnterApplyCheck();
    } else {
      await this.checkOuterChannel({ commodityIds: [this.commodityId] });
    }


    // 新版本获取可支持银行卡列表
    this.getSupportList(
      this.commodityId,
      this.capitalCode,
    );

    await this.getUserInfo();

    // 用户验证 已绑定但未验证过 的银行卡
    if (this.userBankId) {
      await this.getCardNoByUserBankId(this.userBankId);
      /** 若是选卡场景进入”绑卡“，则直接展示提交按钮 */
      this.isInputFormFold = false;

      // 验证银行是否符合规则
      this.autoValidateCardNo();
    }
  }

  private listenQuickBindHistoryOnceEvent(): void {
    const { historyLength: beforeHistoryLength } = this.backQuickBindContext || {};

    if (this.isLoadFromQuickBindBack
      && typeof beforeHistoryLength === 'number'
      && this.$route.path === RouterV2Enum.cardBind) {
      const backStep = beforeHistoryLength - window.history.length;

      window.removeEventListener('popstate', this.listenQuickBindHistoryOnceEvent);
      window.history.go(backStep);
    }
  }

  private handleQuickBindHistoryBack() {
    window.history.pushState({ quickBindBack: '1' }, '');
    window.addEventListener('popstate', this.listenQuickBindHistoryOnceEvent);
  }

  private startQuickBindCard() {
    /** 延迟100ms折叠"输入卡号添加"模块，防止页面闪烁 */
    setTimeout(() => {
      this.isInputFormFold = true;
      this.clearFieldsValidation();
    }, 100);
  }

  private onFocusCardNum() {
    this.isInputFormFold = false;
  }

  // 如果掩码,则不需要验证
  private isPhoneNo(phoneNo: string): boolean {
    return this.shouldMaskPhoneNo || Validator.isPhoneNo(phoneNo);
  }

  private phoneNoFormatter(phoneNo: string): string {
    if (this.shouldMaskPhoneNo) {
      return Formatter.phoneNoFormatter(phoneNo).replace(
        /\s(\d{4})\s/,
        ' **** ',
      );
    }

    return Formatter.phoneNoFormatter(phoneNo);
  }

  // 如果是掩码,则不需要验证
  private isCardNo(cardNo: string): boolean {
    const isValidCardNo = this.shouldMaskCardNo || Validator.isCardNo(cardNo);
    this.isValidCardNo = isValidCardNo;
    return isValidCardNo;
  }

  private cardNoFormatter(cardNo: string): string {
    if (this.shouldMaskCardNo) {
      return Formatter.cardNoFormatter(cardNo).replace(
        /\s(\d{4})\s/,
        ' **** ',
      );
    }

    return Formatter.cardNoFormatter(cardNo);
  }

  private async onPasteCardNum(event: ClipboardEvent) {
    this.isButtonClickable = false;

    if (event.clipboardData) {
      this.$updateState({
        cardNo: event.clipboardData.getData('text/plain') || '',
      });
      // 防止获取银行卡之前进行校验，导致异常
      await this.$nextTick();
      this.autoValidateCardNo();
    }
  }

  // 验证银行是否符合规则
  private autoValidateCardNo() {
    const cardNoField = this.$refs.cardNo as Field;

    if (cardNoField) {
      cardNoField.validate().then((result) => {
        if (!result) {
          this.onCardNoSuccWithDebounce();
        }
      });
    }
  }

  private onChangeCardNum() {
    this.isButtonClickable = false;
  }

  // 获取当前的银行卡信息
  private async getCardInfo() {
    await this.getBankInfoByCardNo({
      commodityId: this.commodityId,
      cardNo: String(this.shouldMaskCardNo ? this.defaultCardNo : this.cardNo).replace(/\s/g, ''),
      checkCapital: this.isCheckCapitalSupport,
      capitalCode: this.capitalCode,
    });
  }

  // 银行卡输入校验通过
  private async onCardNoSucc() {
    if (this.defaultCardNo || this.cardNo) {
      await this.getCardInfo();
    }
    if (this.needContract) {
      await this.getContractList({
        commodityId: this.commodityId,
        capitalCode: this.capitalCode,
      });
      this.isButtonClickable = true;
    } else {
      this.isButtonClickable = true;
    }
  }

  private trackCardBindFailed(exposeName: string) {
    this.$ubtModuleExpose(
      exposeName,
      'commodityId',
      this.commodityId,
      'entryFrom',
      this.entryFromValue,
    );
  }

  private validateBankSupported(): boolean {
    const value = this.tianChengProductId ? true : !(this.isBankSupported === false);
    if (!value) {
      this.trackCardBindFailed('finance_faliedCard');
    }
    return value;
  }

  private async validateBankType(): Promise<boolean> {
    await this.$nextTick();

    /** 重置 卡类型不支持文案提示 */
    this.cardTypeErrorMessage = DEFAULT_CARD_TYPE_NOT_SUPPORT_MSG;

    /** 修复首次更新错误提示值时，不会展示 最新动态设置的 message */
    const updateErrorMessage = (forceFoucs?: boolean) => {
      setTimeout(() => {
        const $messageElem = (this.$refs?.cardNo as Vue)?.$el?.querySelector('[class^="index-module_message"]') as HTMLElement;

        if ($messageElem) {
          $messageElem.innerText = this.cardTypeErrorMessage || '';
        }
        /** 修复IOS 因动态设置msg的原因，输入框光标会突然失焦(与fiance-ui组件有关) */
        if (forceFoucs) {
          const $input = (this.$refs?.cardNo as Vue)?.$el?.querySelector('#cardNo') as HTMLInputElement;

          if ($input) {
            $input.focus();
            $input.setSelectionRange($input.value?.length, $input.value?.length);
          }
        }
      }, 0);
    };

    /** 当银行输入卡号初步校验通过，再进行银行类型校验 */
    if (this.defaultCardNo || this.isCardNo(this.cardNo)) {
      try {
        await this.getCardInfo();
        /**
         * 70016、70019资方，提现流程需屏蔽-兴业银行的银行卡
         * 需求：http://wiki.hellobike.com/pages/viewpage.action?pageId=392765477
         */
        if (this.bankInfo?.checkResult === false && this.bankInfo?.checkMsg) {
          this.cardTypeErrorMessage = this.bankInfo?.checkMsg;
          updateErrorMessage(true);

          return false;
        }

        // 只有储蓄卡校验通过
        if (this.bankInfo && Number(this.bankInfo.cardType) === CardTypeEnum.DebitCard) {
          return true;
        }
        // 如果当前是信用卡，需要增加埋点信息
        if (this.bankInfo && Number(this.bankInfo.cardType) === CardTypeEnum.CreditCard) {
          this.trackCardBindFailed('finance_nonSavingsCard');
        }

        updateErrorMessage();
        return false;
      } catch {
        updateErrorMessage();
        return false;
      }
    } else {
      return true;
    }
  }

  private openSupportList() {
    this.isSupportListVisible = true;
    ubtPageButton(this, 'ShowSupportList', 'entryFrom', this.entryFrom);
  }

  private closeSupportList() {
    this.isSupportListVisible = false;
  }

  private showContracts() {
    if (Validator.isCardNo(this.shouldMaskCardNo ? this.defaultCardNo : this.cardNo)) {
      this.isContractListVisible = true;

      ubtPageButton(this, 'ShowContractList', 'entryFrom', this.entryFrom);
    } else {
      Toast('请先将银行卡号填写完整');

      Vue.nextTick(() => {
        (this.$refs.cardNo as HTMLInputElement).focus();
      });
    }
  }

  private submitForm(errors: ValidateError[]) {
    this.$ubtPageButton(
      'SubmitForm',
      'entryFrom',
      this.entryFrom,
      'productId',
      this.commodityId,
    );
    if (errors.length && errors[0]) {
      Toast(errors[0].message || '');
    } else {
      if (!this.isButtonClickable) {
        Toast.fail('正在校验银行卡号，请稍等');
        return;
      }

      // 如果是倒计时中，则显示短信验证码弹窗
      const smsConfirm = this.$refs.smsConfirm as SmsConfirm;

      if (smsConfirm && smsConfirm.isSmsCountingDown()) {
        this.isSmsDialogVisible = true;
      } else {
        // 渠道ID不能为空或者undefined
        if (!this.commodityId || this.commodityId === 'undefined') {
          Toast('渠道ID不能为空');
        } else {
          const params = {
            commodityId: this.commodityId,
            entryFrom: this.entryFrom,
            capitalCode: this.capitalCode,
            loanOrderId: this.loanOrderId,
          };
          this.sendSmsOrBindCard(params);
        }

        ubtPageButton(
          this,
          'SendSmsOrBindCard',
          'entryFrom',
          this.entryFrom,
          'productId',
          this.commodityId,
        );
      }
    }
  }

  private beforeDestroy() {
    this.$resetState();
  }

  private setCacheDataBeforeLeave(bankInfo: IBankData) {
    const storeCacheData = pickObjectProperty(this as (CardBind & { reservePhone: string, cardNo: string }), [
      'reservePhone',
      'shouldMaskPhoneNo',
      'sendSmsOrBindCardResult',
      'cardNo',
      'shouldMaskCardNo',
      'sendSmsOrBindCardResult',
    ]);
    /** 跳转通联银行签约页，他们可能会新建容器，session存在情况的情况 */
    local.set(BackQuickBindCacheKeys.PAGE_CONTEXT, {
      historyLength: window.history.length,
      bankInfo: {
        bankName: bankInfo.bankName,
        bankLogo: bankInfo.bankLogo,
        cardType: CardTypeEnum.DebitCard,
      },
      storeCacheData,
    });
  }

  private getCacheDataBeforeLeave() {
    const backQuickBindContext = local.get(BackQuickBindCacheKeys.PAGE_CONTEXT);

    if (backQuickBindContext) {
      this.backQuickBindContext = backQuickBindContext as BackQuickBindContext;
      this.$updateState({
        ...(this.backQuickBindContext.storeCacheData || {}),
      });
    }
    /** 清空local缓存 */
    local.set(BackQuickBindCacheKeys.PAGE_CONTEXT, null);
  }

  /** 快捷绑卡成功后回调 */
  private successQuickBindCard(params: QuickBindCardResult, isOriginWebview: boolean) {
    const { bankInfo } = this.backQuickBindContext || {};

    if ([FormInfomation.Credit, FormInfomation.Repay].includes(this.entryFrom)) {
      const { bankName = '', bankLogo = '' } = bankInfo || params;

      this.onCardBindSucc(
        params.bankId,
        params.bankNo,
        { bankName, bankLogo },
        isOriginWebview,
      );
    } else if (this.entryFrom === FormInfomation.QuickWithdraw) {
      /** 来自快速提现的快捷绑卡 */
      /** 延迟跳转，成功Toast可以正常展示 */
      setTimeout(async () => {
        /** 设置本地缓存，银行卡信息 */
        await nativeLocalSetData({
          key: FormInfomation.QuickWithdraw,
          /** 兜底处理，避免值没有的时候，导致本地缓存设置失败 */
          value: [params.bankName || '', params.bankNo || '', params.bankLogo || '', params.bankId || ''],
        });
        /** 关闭webview，返回到快速提现页面 */
        await closeWebView();
      }, 1000);
    } else if (isOriginWebview) {
      /** 提现流程-新开Webview链路 */
      /** 更新银行卡信息 */
      this.updateLoanBankCard({
        bankCard: {
          ...params,
        },
      });
      /** 延迟跳转，成功Toast可以正常展示 */
      setTimeout(() => {
        RouterHelper.setBackConfirm(false);
        RouterHelper.navigate(RouterV2Enum.applyProduct);
      }, 1000);
    } else {
      if (bankInfo) {
        session.set(BackQuickBindCacheKeys.FINAL_RESULT, {
          bindSuccessOnce: true,
          bankCard: {
            bankId: params.bankId,
            bankNo: params.bankNo,
            bankName: bankInfo.bankName,
            bankIcon: bankInfo.bankLogo,
          },
        });
      } else {
        ubtSendError('Quick Bind Not Found BankInfo In SessionStorage');
      }
      /** 延迟跳转，确保结果Toast可以提示成功 */
      setTimeout(() => {
        const { fromHistoryLength } = (local.get(LocalEnum.quickBindCard) || {}) as {fromHistoryLength: number | undefined };

        if (typeof fromHistoryLength === 'number' && fromHistoryLength < window.history.length) {
          const backStep = fromHistoryLength - window.history.length;

          window.history.go(backStep);
        } else {
          ubtSendError(`Quick Bind Calculate 'fromHistoryLength' Value Error: ${String(fromHistoryLength)}`);
          /** 上报ubt埋点数据，还原完整链路数据 */
          this.$ubtModuleExposeNew('fiance_quick_bind_card_error', {
            stage: 'jumpBack',
            fromHistoryLength,
            historyLength: window.history.length,
          });
          RouterHelper.navigate(RouterV2Enum.applyProduct);
        }
      }, 1000);
    }
  }

  private failureQuickBindCard() {
    this.isInputFormFold = false;
  }

  private beforeLeaveBindCardPage(bankInfo: IBankData) {
    this.setCacheDataBeforeLeave(bankInfo);
  }

  private afterBackBindCardPage() {
    this.isLoadFromQuickBindBack = true;

    this.getCacheDataBeforeLeave();
    this.handleQuickBindHistoryBack();
  }

  // 绑卡成功
  private async onCardBindSucc(bankCardId: string, bankNo?: string, quickSelectBank?: { bankName: string, bankLogo: string }, isOriginWebview?: boolean) {
    this.isSmsDialogVisible = false;

    // TODO Toast
    const toastDuration = 1000;
    Toast.success({
      message: '绑卡成功',
      duration: toastDuration,
      forbidClick: true,
    });
    await sleep(toastDuration);

    const bindedBankInfo = quickSelectBank || this.bankInfo || {};

    const inputBankNo = (this.shouldMaskCardNo ? this.defaultCardNo : this.cardNo).replace(/\s/g, '').slice(-4);

    let query = '';

    // 银行预留手机号，脱敏场景取默认值，未脱敏场景 取表单值
    const submitPhone = this.shouldMaskPhoneNo ? String(this.defReservePhone) : this.reservePhone;

    switch (this.entryFrom) {
      // 提现申请
      case FormInfomation.Product:
        /** 更新银行卡信息 */
        this.updateLoanBankCard({
          bankCard: {
            bankId: bankCardId,
            bankName: bindedBankInfo.bankName,
            bankIcon: bindedBankInfo.bankLogo,
            bankNo: bankNo || inputBankNo,
          },
        });
        break;

      case FormInfomation.QuickWithdraw:
        /** 更新银行卡信息 */
        /** 设置本地缓存，银行卡信息 */
        await nativeLocalSetData({
          key: FormInfomation.QuickWithdraw,
          /** 兜底处理，避免值没有的时候，导致本地缓存设置失败 */
          value: [bindedBankInfo.bankName || '', bankNo || inputBankNo, bindedBankInfo.bankLogo || '', bankCardId || ''],
        });
        break;
      case FormInfomation.Repay:
        query = `&cardId=${bankCardId}&bankMobile=${trimAll(submitPhone)}`;
        break;

      default:
        break;
    }

    this.$ubtPageButton(
      'BindCardSucc',
      'entryFrom',
      this.entryFrom,
      'productId',
      this.commodityId,
    );

    RouterHelper.setBackConfirm(false);

    const sessionFrom = session.get(SessionEnum.toBindCard) as SessionFrom;

    if (this.entryFrom === FormInfomation.Credit) {
      /**
       * FormInfomation.Credit场景
       * 微信小程序场景，回退2步(因为小程序是通过location.href先进入列表页)
       * 哈啰app场景，关闭webview
       */
      // eslint-disable-next-line no-unused-expressions
      platform.isWechatMini ? router.go(-1) : closeWebView();
    } else if (this.forwardUrl) {
      jumpToNewVersion(this.forwardUrl, false, `cardId=${bankCardId}&bankMobile=${trimAll(submitPhone)}`);
    } else if (this.entryFrom === FormInfomation.Repay && !sessionFrom) {
      const url = `${this.backPath}${query}`;
      /**
       * 快捷绑卡，动态计算回退步数
       * 普通绑卡，回退2步
       */
      let backStep = -2;

      /** 快捷绑卡场景 && 非新webview链路，动态计算backStep */
      if (quickSelectBank && !isOriginWebview) {
        const maybeStep = Number(this.fromHistoryLength) - window.history.length;
        /** 若是maybeStep不大于0，则说明步数有误，则默认回退5步(普通绑卡2步+ 通联绑卡页面路径2步 + 回跳绑卡页1步) */
        backStep = maybeStep >= 0 ? -5 : maybeStep;
      }

      router.go(backStep);
      localStorage.setItem('bankData', url);
    } else {
      // 检查是否来自快速提现的绑卡请求
      if (this.entryFrom === FormInfomation.QuickWithdraw) {
        /** 关闭webview，返回到快速提现页面 */
        await closeWebView();
        /** 后面再加逻辑，兼容浏览器场景 */
      } else {
        RouterHelper.navigate(sessionFrom ? sessionFrom.back : this.fromPath);
      }
    }
  }

  private renderBankName() {
    if (this.bankInfo) {
      return (
        <Field
          readonly
          name="bankInfo"
          label="卡类型"
          labelWidth={80}
          class={this.isInputFormFold ? style.inputFormInFold : ''}
          labelContentClass={style.newCardBindLabelClass}
          inputContentClass={
            [style.newCardBindInputClass, platform.isIOS && style.iosClass]
          }
          value={`${this.bankInfo.bankName || ''} ${CardTypeNameOptions[this.bankInfo.cardType] || ''}`}
        />
      );
    }

    return null;
  }

  private renderSubmitButton() {
    return (
      <div class={[
        style.footerContent,
        this.contractList.length ? style.contractListWrapper : '',
      ]}>
        <div class={style.contractLine}>
          <span class={style.checkWrap}>
            点击按钮即代表已阅读并同意
          </span>
          <span class={style.contracts} onClick={this.showContracts.bind(this)}>
            <span>《绑卡相关协议》</span>
            {this.getContractNameSY
              ? this.contractList.map(
                (item) => (
                  <span>{`${item.name}`}</span>
                ),
              )
              : null}
          </span>
        </div>
        <div class={style.buttonBar}>
          <button native-type="submit" class={[
            style.submitButton,
            (this.cardNo && this.isValidCardNo) ? '' : style.disabled,
          ]}>
            下一步
          </button>
        </div>
      </div>
    );
  }

  private onFieldBlurValidate($ref: Field) {
    if ($ref && $ref.validate) {
      $ref.validate();
    }
  }

  private clearFieldsValidation() {
    try {
      (this.$refs.reservePhone as FieldComponent).validateMessage = '';
      (this.$refs.cardNo as FieldComponent).validateMessage = '';
    } catch {
      // do nothing
    }
  }

  /**
   * 跳转账号类型信息页
   */
  private goAccountTypeInfo() {
    this.$router.push({
      path: RouterV2Enum.accountTypeInfo,
    });
    this.$ubtPageButtonNew('finance_cardBind_cardTypePrompt');
  }

  private render() {
    const urlQuery = this.$route.query || {};

    return (
      <div class={style.container}>
        {/* 新版样式 */}
        <div class={style.cardBindBox}>
          <p class={style.title}>{urlQuery.userBankId ? '验证银行卡' : '添加银行卡'}</p>
          {/* 安全提示 */}
          <div class={style.safeRemind}>
            <p class={style.remindIcon} />
            <p class={style.remindText}>哈啰承诺保障你的信息安全</p>
          </div>
          {/* 表单输入 */}
          <Form class={style.inputFormBindCard} onSubmit={this.submitFormWithDebounce}>
              {/* 账户类别提示 */}
              <div class={style.accountTypeTip} onClick={this.goAccountTypeInfo.bind(this)}>
                <p class={style.tipText}>建议添加 I类户卡，转账无限额，放款更顺利</p>
                <span class={style.tipIcon} />
              </div>
              <div class={style.formHeader}>
                <div class={style.headerContent}>
                  <p class={style.title}>输卡号添加</p>
                  <div class={style.tools}
                    onClick={() => this.openSupportList()}>
                      <p class={style.supportText}>支持银行</p>
                      <p class={style.supportIcon} />
                  </div>
                </div>
              </div>
              <div class={style.formFieldsNew}>
                <Field
                  ref="reservePhone"
                  name="reservePhone"
                  label="手机号"
                  type="tel"
                  v-model={this.reservePhone}
                  labelWidth={80}
                  maxLength={13}
                  labelContentClass={style.newCardBindLabelClass}
                  inputContentClass={
                    [style.newCardBindInputClass, platform.isIOS && style.iosClass]
                  }
                  placeholder="请输入银行预留手机号"
                  rules={[
                    {
                      required: true,
                      message: '建议银行预留手机号与注册手机号一致',
                    },
                    {
                      trigger: 'onBlur',
                      validator: this.isPhoneNo.bind(this),
                      message: '请填写11位手机号码',
                    },
                    {
                      trigger: 'onInput',
                      validator: this.isPhoneNo.bind(this),
                      message: '请填写11位手机号码',
                    },
                  ]}
                  formatter={this.phoneNoFormatter.bind(this)}
                  onBlur={() => this.onFieldBlurValidate(this.$refs.reservePhone as Field)}
                />
                <Field
                  ref="cardNo"
                  type="tel"
                  name="cardNo"
                  label="银行卡号"
                  v-model={this.cardNo}
                  labelWidth={80}
                  maxLength={26}
                  labelContentClass={style.newCardBindLabelClass}
                  inputContentClass={
                    [style.newCardBindInputClass, platform.isIOS && style.iosClass]
                  }
                  placeholder="请输入该手机号绑定的卡号"
                  rules={[
                    {
                      required: true,
                      message: '请输入15-21位的银行卡号',
                    },
                    {
                      trigger: 'onBlur',
                      validator: this.isCardNo.bind(this),
                      message: '请输入15-21位的银行卡号',
                    },
                    {
                      trigger: 'onInput',
                      validator: this.validateBankSupported.bind(this),
                      message: '不支持该银行，请更换其他银行卡',
                    },
                    {
                      trigger: 'onInput',
                      validator: this.validateBankType.bind(this),
                      message: this.cardTypeErrorMessage,
                    },
                  ]}
                  formatter={this.cardNoFormatter.bind(this)}
                  onSuccess={this.onCardNoSuccWithDebounce}
                  onPaste={this.onPasteCardNum.bind(this)}
                  onChange={this.onChangeCardNum.bind(this)}
                  onFocus={this.onFocusCardNum.bind(this)}
                  onBlur={() => this.onFieldBlurValidate(this.$refs.cardNo as Field)}
                >
                </Field>
                {this.renderBankName()}
              </div>
              {/** 底部提交按钮 */}
              {this.renderSubmitButton()}
            </Form>
        </div>
        <ContractList
          entryFrom={this.entryFrom}
          commodityId={this.commodityId}
          capitalCode={this.capitalCode}
          v-model={this.isContractListVisible}
        />
        <SmsConfirm
          ref="smsConfirm"
          entryFrom={this.entryFrom}
          commodityId={this.commodityId}
          capitalCode={this.capitalCode}
          loanOrderId={this.loanOrderId}
          v-model={this.isSmsDialogVisible}
          onBindSucc={this.onCardBindSucc.bind(this)}
        />
        <SupportList
          visible={this.isSupportListVisible}
          productId={this.commodityId}
          capitalCode={this.capitalCode}
          onCloseSupportList={() => this.closeSupportList()}
        />
        {platform.isHelloApp && (
          <QuickBindCard
            title="免输卡号添加"
            class={style.quickBindCard}
            productId={this.commodityId}
            capitalCode={this.capitalCode}
            bindCardScene={BindCardFlowTypeMap[this.entryFrom]}
            useNewWebviewForJump={this.isQuickBindByUseNewWebview}
            onStartQuickBindCard={() => this.startQuickBindCard()}
            onSuccessQuickBindCard={(params: QuickBindCardResult, isOriginalWebview: boolean) => this.successQuickBindCard(params, isOriginalWebview)}
            onFailureQuickBindCard={() => this.failureQuickBindCard()}
            onBeforeLeaveBindCardPage={(bankData: IBankData) => this.beforeLeaveBindCardPage(bankData)}
            onAfterBackBindCardPage={() => this.afterBackBindCardPage()}
          />
        )}
      </div>
    );
  }
}
